import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="relative py-28 md:py-32 px-4 bg-[#F7F3E9] overflow-hidden" data-id="element-256">
      {/* Decorative background elements */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-257">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#FFD166]/20 via-transparent to-transparent blur-[100px]" data-id="element-258"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10 flex flex-col md:flex-row items-center gap-16 lg:gap-24" data-id="element-259">
        {/* Ebook Image Mockup */}
        <motion.div initial={{
        opacity: 0,
        x: -50,
        rotateY: -10
      }} whileInView={{
        opacity: 1,
        x: 0,
        rotateY: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="w-full md:w-1/2 flex justify-center" style={{
        perspective: '1000px'
      }} data-id="element-260">
          <div className="relative w-full max-w-md" data-id="element-261">
            {/* Soft glow behind book */}
            <div className="absolute -inset-6 bg-[#FFD166]/30 rounded-[3rem] blur-2xl -z-10" data-id="element-262"></div>

            <img src="https://cdn.magicpatterns.com/uploads/s2wh1etg2tDd7vNYD6w5qp/ChatGPT_Image_9_mar_2026,_11_52_04_a.m..png" alt="Camino a la Luz Ebook Cover" className="relative w-full h-auto rounded-2xl shadow-2xl shadow-[#2F3A3D]/20 transform transition-transform duration-700 hover:scale-105 hover:-rotate-1" data-id="element-263" />
          </div>
        </motion.div>

        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full md:w-1/2 space-y-10 text-center md:text-left" data-id="element-264">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-serif text-[#2F3A3D] leading-[1.1]" data-id="element-265">
            La guía que te ayudará a volver a ver la luz
          </h2>

          <div className="space-y-8" data-id="element-266">
            <p className="text-xl text-[#5F6368] leading-relaxed" data-id="element-267">
              <strong className="font-serif text-[#F4A261] text-2xl" data-id="element-268">
                Camino a la Luz
              </strong>{' '}
              es una guía práctica diseñada para ayudarte a comprender la
              depresión y comenzar un proceso de recuperación emocional paso a
              paso.
            </p>

            <div className="p-8 bg-white rounded-3xl border border-[#E8E1D5] shadow-[0_10px_30px_rgba(47,58,61,0.08)]" data-id="element-269">
              <p className="text-xl text-[#2F3A3D] font-medium leading-relaxed" data-id="element-270">
                Aprenderás herramientas claras para recuperar tu bienestar
                mental y emocional.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}